import Hero from './Hero';
import Features from './Features';
import HowItWorks from './HowItWorks';
import Web3Banner from './Web3Banner';
import FAQ from './FAQ';

export const metadata: Metadata = {
  title: 'Threads Video Downloader',           // Ini akan jadi judul halaman
  description: 'Download video Threads dengan kualitas terbaik dan tanpa watermark.',
  // Bisa tambah keywords, openGraph, dll
};


export default function Threads() {
  return (
    <>
      <Hero />
      <Features />
      <HowItWorks />
      <Web3Banner />
      <FAQ />
    </>
  );
}